import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { JoykitIcon, JoykitIconVariant } from '@components/JoykitIcon';
import {
  StyledValuePropTextItem,
  StyledValuePropAncorItem,
  StyledValuePropText,
  StyledValuesProp,
  StyledValuePropDescription,
} from './ValuePropsSection.styles';

export interface ValuePropsArg {
  id: string;
  url?: string;
  icon: JoykitIconVariant;
  title: string;
  elementId?: string;
  description?: string;
}

export type ValueProps = {
  elementId?: string;
  values: Array<ValuePropsArg>;
  maxWidth?: string;
  onClick?: (e: React.MouseEvent, url: string, name: string) => void;
};

export const ValuePropsSection: React.FC<ValueProps> = ({ elementId, values, maxWidth, onClick = () => {} }) => {
  return (
    <StyledValuesProp maxWidth={maxWidth}>
      {values.map((valueProp) =>
        valueProp.url ? (
          <StyledValuePropAncorItem
            key={valueProp.id}
            id={valueProp.id}
            href={valueProp.url || ''}
            variant="neutraLink"
            target="_blank"
            aria-label={valueProp.title}
            data-element-id={elementId}
            onClick={(e) => onClick(e, valueProp.url || '', valueProp.title)}
          >
            <JoykitIcon name={valueProp.icon} color="neutra5" />
            <StyledValuePropText variant="sectionEyeBrow24" tagName="h2">
              {ReactHtmlParser(valueProp.title)}
            </StyledValuePropText>
          </StyledValuePropAncorItem>
        ) : (
          <StyledValuePropTextItem variant="caption" tagName="span" key={valueProp.id} id={valueProp.id}>
            <JoykitIcon name={valueProp.icon} color="neutra5" />
            <StyledValuePropText variant="sectionEyeBrow24" tagName="h2" css={{ whiteSpace: 'break-spaces' }}>
              {ReactHtmlParser(valueProp.title)}
            </StyledValuePropText>
            {valueProp.description && (
              <StyledValuePropDescription variant="dek20" tagName="h3" css={{ whiteSpace: 'break-spaces' }}>
                {ReactHtmlParser(valueProp.description)}
              </StyledValuePropDescription>
            )}
          </StyledValuePropTextItem>
        )
      )}
    </StyledValuesProp>
  );
};
